// removed by extract-text-webpack-plugin
module.exports = {"root":"_2aTOB9u","savePrompt":"mxO6VCh","icon":"_36VvJlf","saveDescription":"_2uKQhBc"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SavePanel/components/JobMailNew/JobMailWrapper.less
 ** module id = 880
 ** module chunks = 0
 **/